export enum BaseCustomerWorkCouncilStatusEnum {
  APPROVED = 'approved',
  DISAPPROVED = 'disapproved',
  AUTO_APPROVED = 'automatically_approved',
  NOTED = 'noted',
}
